import { getValue } from "firebase/remote-config";
import { remoteConfig } from "../firebase-config";

export const RemotePrams = {
  HTML_ALLOWED_TAGS: "html_allowed_tags",
  HTML_NOT_ALLOWED_TAGS: "html_invalid_words",
  APPLE_TRADEMARKS: "apple_trademarks",
  TC_REPLACE: "tc_replace",
  MAX_PARKING: "max_parking",
  MAX_ROOMS: "max_rooms",
};

export const RemoteDefaultConfig = {
  max_parking: 10,
  max_rooms: 10,
  html_allowed_tags: [
    "HTML",
    "HEAD",
    "BODY",
    "META",
    "STYLE",
    "P",
    "DIV",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "UL",
    "OL",
    "LI",
    "BLOCKQUOTE",
    "B",
    "I",
    "S",
    "U",
    "O",
    "SUP",
    "INS",
    "DEL",
    "STRONG",
    "STRIKE",
    "TT",
    "CODE",
    "BIG",
    "SMALL",
    "BR",
    "SPAN",
    "EM",
  ],
  html_invalid_words: [
    "Apple Wallet Pay",
    "Apple Pay Virtual Wallet",
    "Apple Pay Wallet",
    "�",
    "@font-face",
    "font-family",
    "@list",
    "<!--[if",
    "<![endif]-->",
    ".css",
    ".js",
    ".json",
    ".php",
    ".html",
    ".htm",
    ".aspx",
  ],
  apple_trademarks: [
    "3D Touch",
    "Afterburner",
    "AirDrop",
    "AirMac",
    "AirPlay",
    "AirPlay Logo",
    "AirPods",
    "AirPods Max",
    "AirPods Pro",
    "AirPort",
    "AirPort Express",
    "AirPort Extreme",
    "AirPort Time Capsule",
    "AirPower",
    "AirPrint",
    "AirTag",
    "AirTunes",
    "Animoji",
    "Aperture",
    "App Clip Code",
    "App Clips",
    "Apple",
    "Apple logo",
    "Apple Books",
    "Apple Card",
    "Apple CarPlay",
    "Apple Cash",
    "Apple Cinema Display",
    "Apple Immersive Video",
    "Apple Intelligence",
    "Apple Invites",
    "Apple Link",
    "Apple Music",
    "Apple Pay",
    "Apple Pencil",
    "Apple Pencil Pro",
    "Apple Pro Display XDR",
    "Apple Remote Desktop",
    "AppleScript",
    "AppleScript Studio",
    "Apple Share",
    "Apple Studio Display",
    "AppleTalk",
    "Apple TV",
    "AppleVision",
    "Apple Vision Pro",
    "Apple Wallet",
    "Apple Watch",
    "Apple Watch SE",
    "Apple Watch Edition",
    "Apple Watch Sport",
    "iPhone",
    "iPhone SE",
    "iPhone Mini",
    "iPhone Pro",
    "iPhone Pro Max",
    "iPad",
    "iPad Mini",
    "iPad Air",
    "iPad Pro",
    "MacBook",
    "MacBook Air",
    "MacBook Pro",
    "Mac Mini",
    "iMac",
    "iMac Pro",
    "Mac Pro",
    "Mac Studio",
    "Apple Silicon (M1, M2, M3 etc)",
    "HomePod",
    "HomePod mini",
    "Magic Keyboard",
    "Magic Mouse",
    "Magic Trackpad",
    "Apple TV 4K",
    "Siri Remote",
    "MagSafe Charger",
    "MagSafe Battery Pack",
    "MagSafe Duo Charger",
    "EarPods",
    "Apple Polishing Cloth",
    "Apple Pencil (USB-C)",
    "Apple Pencil 2nd Generation",
    "Apple Watch Ultra",
    "Apple Watch Series (1–10)",
    "Apple Fitness+",
    "Apple One",
    "Apple News+",
    "Apple Arcade",
    "Apple TV+",
    "bridgeOS",
    "macOS",
    "iOS",
    "iPadOS",
    "tvOS",
    "visionOS",
    "HomePod Software",
  ],
  tc_replace: [
    {
      word: "Apple Wallet Pay",
      replaceWith: "Apple Wallet or Apple Pay",
    },
    {
      word: "Apple Wallet App",
      replaceWith: "Apple Wallet or Apple Pay",
    },
    {
      word: "Apple Pay Virtual Wallet",
      replaceWith: "Apple Wallet or Apple Pay",
    },
    {
      word: "Apple Pay Wallet",
      replaceWith: "Apple Wallet or Apple Pay",
    },
    {
      word: "Apple Pay App",
      replaceWith: "Apple Wallet or Apple Pay",
    },
    {
      word: "Wallet app",
      replaceWith: "Apple Wallet or Apple Pay",
    },
    {
      word: "Find My App",
      replaceWith: "Find My",
    },
  ],
};

export function getRemoteString(config) {
  return getValue(remoteConfig, config).asString();
}
export function getRemoteNumber(config) {
  return getValue(remoteConfig, config).asNumber();
}

export function getRemoteBoolean(config) {
  return JSON.parse(getValue(remoteConfig, config).asBoolean());
}

export function getRemoteJSON(config) {
  return JSON.parse(getValue(remoteConfig, config).asString());
}
